import React, { Fragment } from 'react'

import * as styles from './SocialIcon.module.scss'
import { Icon } from '@iconify/react'
const SocialIcon = ({ color, type, inline, iconSet = false }) => {
  //parent el needs display flex
  const iconTypes = {
    twitter: 'ri:twitter-x-fill',
    youtube: 'cib:youtube',
    instagram: 'cib:instagram',
    linkedin: 'cib:linkedin-in',
    facebook: 'cib:facebook-f',
  }
  const iconLinks = {
    twitter: 'https://twitter.com/Go_Precise',
    youtube: 'https://www.youtube.com/channel/UC3VgyysRIEnartLovVpDJOQ',
    instagram: 'https://www.instagram.com/goprecise/',
    linkedin: 'https://www.linkedin.com/company/precise-systems-inc-/',
    facebook: 'https://www.facebook.com/GoPrecise/',
  }

  if (type === 'facebook') {
    iconSet = false
  }

  return (
    <Fragment>
      <a
        aria-label={`${iconTypes[`${type}`]} Link`}
        href={iconLinks[type]}
        target="_blank"
        rel="noreferrer"
        className={`${styles.hexagonBG} ${styles[`${color}`]}`}
      >
        <Icon
          icon={iconTypes[type]}
          className={`${styles.social__icon}`}
          inline={inline}
        />
      </a>
      <div
        className={`${styles.socialMedia__trim} ${styles[`${color}`]} ${
          iconSet ? styles.showTrim : ''
        }`}
      ></div>
    </Fragment>
  )
}

export default SocialIcon
